import React, 
     { useState , 
       useEffect,
       useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Container         from '@mui/material/Container'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import { useHistory }    from "react-router-dom"
import GBTitle           from './GBTitle'
import GBOpening         from "./GBOpening"
import CalculationSelect from './CalculationModeSelect'
import GameMain          from "./GameMain"
import GameStart         from "./GameStart"
import GBDirectionalPad  from "./GB_DirectionalPadKey"
import GameModeSelect    from './GameModeSelect'
import KanjiGame         from "./KanjiGame"
import GakunenSelect     from './GakunenSelect'
import A_Button          from './A_Button'
import B_Button          from './B_Button'
import SELECT_Button     from './SELECT_Button'
import START_Button      from './START_Button'
import store             from '../../store'
import '../../App.css'
import '../../style.css';
import { Button } from '@mui/material'

// --------------------定数---------------------
export const baseId         = "molecule-game-boy-logo";
const UIMODE_OPENING        = "opening"
const UIMODE_CALUCSELECT    = "calcselect"
const UIMODE_SELECT         = "modeSelect"
const UIMODE_MAIN           = "main"
const UIMODE_TITLE          = "title"
const UIMODE_START          = "start"
const UIMODE_KANJI_GAME     = "kanji"
const UIMODE_GAKUNEN_SELECT = "gakunenSelect"
const OpeningMusic          = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F01%20%EF%BD%9E%E3%82%AA%E3%83%BC%E3%83%95%E3%82%9A%E3%83%8B%E3%83%B3%E3%82%AF%E3%82%99%EF%BD%9E.wav?alt=media&token=51d966d0-66c9-49f4-bbd7-14809288d135"
const GameMusic             = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F21%20%E3%83%9E%E3%82%B5%E3%82%AD%E3%81%AE%E3%82%82%E3%81%A8%E3%81%B8%EF%BC%8D%E3%83%8F%E3%83%8A%E3%82%BF%E3%82%99%E3%82%88%E3%82%8A.wav?alt=media&token=77399b16-4558-4b95-ac73-c458c8ae3a52"
const PokemonBatle          = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F07%20%E6%88%A6%E3%81%84%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=8dacd0f2-c1ee-4394-85e3-0eaca290ea15"
const PokemonVictory        = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F08%20%E5%8B%9D%E5%88%A9%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=d757071f-c712-42fa-8644-e4022c809b60"

function GBUI() {
  console.log("選択中のゲームモード:",store.getState().GameModeSelect)
  console.log("選択中の計算式:",store.getState().CalcSelect)
  console.log("YES NO ラベル" , store.getState().SelectYesNo)
  const [currentUI  , setCurrentUI  ] = useState(UIMODE_TITLE) // openingを初期値として設定
  // const [selectedLabel , setSelectedLabel] = useState("tashi")  // 最初はたしざんから始まる
  // const [calcLabel     , setCalcLabel]     = useState("kokugo")  // 最初はこくごから始まる
  const history = useHistory()

  // 音楽が流れる
  const [audio]           = useState(new Audio(OpeningMusic))
  const [gameMusic]       = useState(new Audio(GameMusic))
  const [battleAudio]     = useState(new Audio(PokemonBatle))
  const [pokemonVictory ] = useState(new Audio(PokemonVictory))
  const [isPlaying, setIsPlaying] = useState(false)

  // オープニング音楽を再生
  const startaudioPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    audio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      audio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }
  // ゲーム選択音楽を再生
  const startGameMusicPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    gameMusic.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      gameMusic.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // すべての音楽を停止する
  const AllMusicPause = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
  }

  // 初回起動時の処理
  useEffect(() => {
    
    store.getState().GameUI = UIMODE_TITLE
    // コンポーネントがマウントされたときに音楽を再生
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止

    setIsPlaying(true)

    // コンポーネントがアンマウントされるときに音楽を停止
    return () => {
      audio.pause() // 停止
    }
  }, [audio]);

  // STARTボタンクリック時の処理
  const handleClickStartButton = () => {
    // 現在のUIがopeningならmainに、mainならmodeSelectに、modeSelectならopeningに切り替える
    switch (currentUI) {
      // タイトル画面表示
      case UIMODE_TITLE:
        console.log("UIMODE_TITLEを通過")
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      // オープニング画面表示
      case UIMODE_OPENING:
        console.log("UIMODE_OPENINGを通過")
        startGameMusicPlay() // 再生
        store.getState().GameUI = UIMODE_START
        setCurrentUI(UIMODE_START)
        console.log("画面状態：",store.getState().GameUI)
        break

      // ゲーム選択表示
      case UIMODE_START:
        console.log("UIMODE_STARTを通過")
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      default:
        break
    }
  }

  // Aボタンクリック時の処理
  const handleClick_A_Button = () => {
    switch (currentUI) {
      // ゲーム選択画面表示
      case UIMODE_START:
        console.log("YES or NO =>",store.getState().SelectYesNo)
        // 「はい」か「いいえ」のどちらか判定
        if(store.getState().SelectYesNo == "yes"){
          // 「はい」が選ばれている場合
          // 選択しているゲームモードが算数か国語で判定
          if(store.getState().GameModeSelect == "sansuu"){
            AllMusicPause() // 停止
            store.getState().GameUI = UIMODE_MAIN
            setCurrentUI(UIMODE_MAIN)
            console.log("画面状態：",store.getState().GameUI)
          }else{  
            AllMusicPause() // 停止
            store.getState().GameUI = UIMODE_KANJI_GAME
            setCurrentUI(UIMODE_KANJI_GAME)
            console.log("画面状態：",store.getState().GameUI)
          }
        }else{
          // 「いいえ」が選ばれている場合
          startaudioPlay() // 再生
          store.getState().GameUI = UIMODE_OPENING
          setCurrentUI(UIMODE_OPENING)
          console.log("画面状態：",store.getState().GameUI)
          }

        break

        // オープニング画面表示
      case UIMODE_SELECT:
        if (store.getState().GameModeSelect === "sansuu"){
          // さんすうを選択した場合の処理
          store.getState().GameUI = UIMODE_CALUCSELECT
          setCurrentUI(UIMODE_CALUCSELECT)
          console.log("画面状態：",store.getState().GameUI)
        }else{
          // こくごを選択した場合の処理
          store.getState().GameUI = UIMODE_GAKUNEN_SELECT
          setCurrentUI(UIMODE_GAKUNEN_SELECT)
          console.log("画面状態：",store.getState().GameUI)
        }
        break

      // 計算式選択画面表示
      case UIMODE_CALUCSELECT:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break
      
      // 学年選択画面表示
      case UIMODE_GAKUNEN_SELECT:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      default:
        break
    }
  }

  // Bボタンクリック時の処理
  const handleClick_B_Button = () => {
    switch (currentUI) {
      // ゲーム選択画面表示
      case UIMODE_START:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      // オープニング画面表示
      case UIMODE_SELECT:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      // 計算の種類選択画面表示
      case UIMODE_CALUCSELECT:
      // 学年選択画面表示
      case UIMODE_GAKUNEN_SELECT:
        store.getState().GameUI = UIMODE_SELECT
        setCurrentUI(UIMODE_SELECT)
        console.log("画面状態：",store.getState().GameUI)
        break

        // ゲーム実行中画面
      case UIMODE_MAIN:
      case UIMODE_KANJI_GAME:
        window.location.reload()
        break
      default:
        break
    }
  }
  
  // 十字ボタンクリック時の処理
  const handleClick_DirectionalPadKey = () => {
    console.log("十字キー")
  }

  // SELECT_Buttonがクリックされたときの処理を記述
  const handleClickSelectButton = () => {
    switch (currentUI) {
      // オープニング画面表示
      case UIMODE_OPENING:
        startGameMusicPlay() // 再生
        store.getState().GameUI = UIMODE_SELECT
        setCurrentUI(UIMODE_SELECT)
        console.log("画面状態：",store.getState().GameUI)
        break
      // ゲーム選択画面
      case UIMODE_SELECT:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break
      default:
        break
    }
  }

  // currentUIに基づいて表示するコンポーネントを選択
  const renderUIComponent = () => {
    switch (currentUI) {
      // スタートボタンを押してね画面
      case UIMODE_TITLE:
        return <GBTitle />
      // ゲームタイトル画面
      case UIMODE_OPENING:
        return <GBOpening />
      // ゲーム画面
      case UIMODE_MAIN:
        return <GameMain />
      // 計算式選択画面
      case UIMODE_CALUCSELECT:
        return <CalculationSelect />
      // ゲームモード選択画面
      case UIMODE_SELECT:
        return <GameModeSelect />
      // ゲーム開始選択画面
      case UIMODE_START:
        return <GameStart />
      // 学年選択画面
      case UIMODE_GAKUNEN_SELECT:
        return <GakunenSelect/>
      // 漢字ゲーム画面
      case UIMODE_KANJI_GAME:
        return <KanjiGame />

        default:
        return null;
    }
  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        <Container  maxWidth="sm" sx={{ width: '500px' }}>
          {/* 本体外枠 */}
          <Box sx={{ flexGrow: 1,
                    bgcolor      : '#C83031' ,
                    borderRadius : "15px"    , 
                    height       : "700px"   ,
                    width        : '410px'   ,
                    position     : 'relative', // 相対位置指定
                  }}>
            <Grid container spacing={2}>
              <Grid item xs={12} align="center"></Grid>
            </Grid>

            {/* 画面外枠 */}
            <Paper
                sx={{
                m            : 1          ,
                p            : 1          ,
                borderRadius : "13px"     ,
                height       : "330px"    ,
                width        : '350px'    ,
                bgcolor      : '#222222'  ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '15px'     , // 横位置を20pxに指定
                }}>

                {/* POWERフォント */}
                <Typography 
                    sx={{
                        // フォントをメイリオに設定
                        fontFamily   : 'Meiryo'      , // メイリオ
                        fontStyle    : 'italic'      , // 斜体に設定
                        fontSize     : "9px"        , 
                        bgcolor      : 'transparent' ,
                        color        : 'white'       , // フォントの色を白に設定
                        position     : 'absolute'    , // 絶対位置指定
                        top          : '60px'        , // 縦位置を50pxに指定
                        left         : '10px'        , // 横位置を20pxに指定
                    }}><span style={{ color: 'red' }}>●</span> ) ) )
                </Typography>
                <Typography 
                    sx={{
                        // フォントをメイリオに設定
                        fontFamily   : 'Meiryo'      , // メイリオ
                        fontStyle    : 'italic'      , // 斜体に設定
                        fontSize     : "9px"        , 
                        bgcolor      : 'transparent' ,
                        color        : 'white'       , // フォントの色を白に設定
                        position     : 'absolute'    , // 絶対位置指定
                        top          : '80px'        , // 縦位置を50pxに指定
                        left         : '10px'        , // 横位置を20pxに指定
                    }}>POWER
                </Typography>

                {/* 画面表示 */}
                {/* {currentUI === "opening" ? <GBOpening /> : <GameMain />} */}
                {renderUIComponent()}

                {/* ゲームボーイのロゴ */}
                <Grid container spacing={0}>
                    <Typography 
                        sx={{
                        // フォントをメイリオに設定
                        fontFamily   : 'Meiryo'       , // メイリオ
                        fontStyle    : 'italic'       , // 斜体に設定
                        fontWeight   : 'bold'         , // 太字に設定
                        fontSize     : "24px"         , 
                        bgcolor      : 'transparent'  ,
                        color        : 'white'        , // フォントの色を白に設定
                        position     : 'absolute'     , // 絶対位置指定
                        top          : '305px'        , // 縦位置を50pxに指定
                        left         : '70px'        , // 横位置を20pxに指定
                        }}>GAME BOY
                    </Typography>
                    <Typography 
                        sx={{
                        // 独自フォントに設定
                        fontFamily   : 'Kalam'        , // Kalamフォント
                        fontStyle    : 'italic'       , // 斜体に設定
                        fontWeight   : 'bold'         , // 太字に設定
                        fontSize     : "24px"         , 
                        bgcolor      : 'transparent'  ,
                        color        : 'white'        , // フォントの色を白に設定
                        position     : 'absolute'     , // 絶対位置指定
                        top          : '305px'        , // 縦位置を50pxに指定
                        left         : '220px'        , // 横位置を20pxに指定
                        }}>
                        <span style={{ color: '#FB4E8B' }}>C</span>
                        <span style={{ color: '#AE97F1' }}>O</span>
                        <span style={{ color: '#BBE880' }}>L</span>
                        <span style={{ color: '#FAEB67' }}>O</span>
                        <span style={{ color: '#8CD0FF' }}>R</span>
                    </Typography>
                </Grid>
            </Paper>

            {/* Nintendo ロゴ */}
            <Typography
                sx={{
                  fontStyle    : 'italic'       , // 斜体に設定
                  fontWeight   : 'bold'         , // 太字に設定
                  fontSize     : "15px"         , 
                  bgcolor      : 'transparent'  ,
                  color        : '#696969'        , // フォントの色を白に設定
                  position     : 'absolute'     , // 絶対位置指定
                  top          : '390px'        , // 縦位置を50pxに指定
                  left         : '160px'        , // 横位置を20pxに指定
                  border       : '2px solid #696969', // 枠線の太さと色を設定
                  borderRadius : '15px'         , // 角丸の半径を設定
                  padding      : '0 10px'       , // 上下0px、左右20pxの余白を設定
              }}>Nintendo</Typography>

            {/* 十字キー(上ボタン) */}
            <GBDirectionalPad 
              onClick={handleClick_DirectionalPadKey}/>

            {/* Aボタン */}
            <A_Button 
              onClick={(event) => handleClick_A_Button({ key: 'Enter', target: { value: 'yes' } })}/>

            {/* Bボタン */}
            <B_Button 
              onClick={(event) => handleClick_B_Button()}/>
          
            {/* SELECTボタン */}
            <SELECT_Button 
              onClick={handleClickSelectButton}/>
            {/* <SELECT_Button/> */}

            {/* STARTボタン */}
            <START_Button
              onClick={handleClickStartButton} />

            <Grid container spacing={2}>
              <Grid item xs={12} align="center">
              </Grid>
            </Grid>
          </Box>
          
          {/* 操作案内 */}
          <Grid container spacing={2}>
            <Grid item xs={12} align="left">
              <Typography>SELECTボタンでゲームモードをせんたく<br/>(さんすう or こくご)</Typography>
            </Grid>
            <Grid item xs={12} align="left">
              <Typography>【さんすうモード】<br/>こたえをすうじで入力してエンターキーでけってい</Typography>
            </Grid>
            <Grid item xs={12} align="left">
              <Typography>【こくごモード】<br/>かくすうをすうじで入力してエンターキーでけってい</Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
  );
}

export default GBUI;
